
//import axios from 'axios';
import axios from 'axios';
export const allowTags = ['iframe','image','a','p','li','ul','span','strong','br','img', 'blockquote', 'abbr','h1','h2','h3','h4','h5','h6','hr','hr', 'ol','sup','sub','b','i','u','em','s','strike','del','pre','table','thead','tbody','tfoot','tr','th','td','div','dd','dl','dt','embed','source','video','audio','canvas','svg','legend','datalist']
export const url = 'https://aqcaplatform.prosoft.kg'

export const api = 'https://aqcaplatform.prosoft.kg/api/'
export const main = 'https://aqcaplatform.prosoft.kg/api/main_page/'
export const events = 'https://aqcaplatform.prosoft.kg/api/events/'
export const news = 'https://aqcaplatform.prosoft.kg/api/news/';
export const resources = 'https://aqcaplatform.prosoft.kg/api/resources/';

export const uri = 'https://jashtar.info/';
export const base =
  'https://my-json-server.typicode.com/MalikImansaparov/json-server/analytics';
export const limitUrl =
  'https://my-json-server.typicode.com/MalikImansaparov/json-server/analytics?_limit=4';
export const newsUrl = '19fba0e995b9794fc2c26217bf3b725c2f0d9eeda16719fe75e3ba23ca73bfc4'
export const mainUrl = 'd16a80a43d7a3d5a56ed355931766b681f849b2b99a91b99f2ecf10d5d4797df'
export const galeryUrl = 'ce387d5e0a2972dea9e5129a52ac3b8d58a4d180fc9eece5946d926643a3d2c0'
export const aboutUrl = 'f4116002dd4697f6b3a8434f253e4069674c2b6aeadf0bdba1e8fc683337c11d'
export const searchUrl = 'd16a80a43d7a3d5a56ed355931766b681f849b2b99a91b99f2ecf10d5d4797df'

export const month = {
    "01": "jan",
    "02": "feb",
    "03": "march",
    "04": "apr",
    "05": "may",
    "06": "june",
    "07": "july",
    "08": "aug",
    "09": "sep",
    "10": "oct",
    "11": "nov",
    "12": "dec",
}
